import * as React from 'react';
import { SVGProps } from 'react';

const SvgClassesAndEvents = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M31.25 18.83v7.74c0 3.82-5.04 6.92-11.25 6.92s-11.25-3.1-11.25-6.92v-7.12"
    />
    <path
      fill="currentColor"
      d="M20 7.68 36.65 16l-16.64 8.32L3.35 16 20 7.68ZM20 6 0 16l20.01 10L40 16 20 6Z"
    />
    <path
      fill={props.fill}
      d="m14.41 23.21 5.6 2.79L40 16H28.83l-14.42 7.21Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m19.93 17.29 5.78 5.79v3.61"
    />
    <path
      fill="currentColor"
      d="M25.71 27.98a1.88 1.88 0 1 0 0-3.76 1.88 1.88 0 0 0 0 3.76Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.25}
      d="m24.17 28.8 1.54-1.54 1.55 1.54m-1.55.62v-2.11"
    />
  </svg>
);

export default SvgClassesAndEvents;
